module.exports = __webpack_public_path__ + "img/selected_virtual_on.67207a27.svg";